var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297.5,
    height: 297.5,
    viewBox: "0 0 290 290",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D3C3C",
    strokeWidth: 8.5,
    fillOpacity: 0,
    x1: 250.5402,
    y1: 200.16765,
    x2: 46.95979,
    y2: 200.16765,
    id: "svg_26"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D3C3C",
    strokeWidth: 8.5,
    fillOpacity: 0,
    x1: 241.63938,
    y1: 218.38997,
    x2: 55.86062,
    y2: 218.38997,
    id: "svg_28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    strokeWidth: 9.5,
    opacity: "undefined",
    d: "m23.34212,79.21352c0,-0.21723 0.22832,-0.3998 0.50001,-0.3998l72.33336,0c0.2717,0 0.50001,0.18256 0.50001,0.3998l0,93.20061c0,0.21724 -0.22831,0.39983 -0.50001,0.39983l-72.33336,0c-0.27169,0 -0.50001,-0.18259 -0.50001,-0.39983l0,-93.20061z",
    id: "svg_1",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 12,
    fillOpacity: 0,
    x1: 41.71241,
    y1: 105.72271,
    x2: 77.71262,
    y2: 105.27827,
    id: "svg_5",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10.5,
    fillOpacity: 0,
    x1: 34.88375,
    y1: 132.24134,
    x2: 85.13386,
    y2: 131.79689,
    id: "svg_6",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10,
    fillOpacity: 0,
    x1: 34.58746,
    y1: 146.46357,
    x2: 84.83757,
    y2: 146.01912,
    id: "svg_8",
    stroke: "#3D3C3C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    strokeWidth: 9.5,
    opacity: "undefined",
    d: "m112.08329,79.50982c0,-0.21723 0.22832,-0.3998 0.50002,-0.3998l72.33337,0c0.27173,0 0.5,0.18256 0.5,0.3998l0,93.20061c0,0.21721 -0.22827,0.39981 -0.5,0.39981l-72.33337,0c-0.27171,0 -0.50002,-0.1826 -0.50002,-0.39981l0,-93.20061z",
    id: "svg_3",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    strokeWidth: 9.5,
    opacity: "undefined",
    d: "m112.08329,79.50982c0,-0.21723 0.22832,-0.3998 0.50002,-0.3998l72.33337,0c0.27173,0 0.5,0.18256 0.5,0.3998l0,93.20061c0,0.21721 -0.22827,0.39981 -0.5,0.39981l-72.33337,0c-0.27171,0 -0.50002,-0.1826 -0.50002,-0.39981l0,-93.20061z",
    id: "svg_10",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 11.5,
    fillOpacity: 0,
    x1: 130.74988,
    y1: 105.72271,
    x2: 166.75009,
    y2: 105.27827,
    id: "svg_11",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10,
    fillOpacity: 0,
    x1: 124.21752,
    y1: 131.05617,
    x2: 174.46762,
    y2: 130.61172,
    id: "svg_12",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10,
    fillOpacity: 0,
    x1: 123.62493,
    y1: 144.68582,
    x2: 173.87503,
    y2: 144.24137,
    id: "svg_14",
    stroke: "#3D3C3C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    strokeWidth: 10.5,
    opacity: "undefined",
    d: "m201.12079,79.50982c0,-0.21724 0.2283,-0.3998 0.5,-0.3998l72.3334,0c0.27173,0 0.5,0.18256 0.5,0.3998l0,93.20061c0,0.21724 -0.22827,0.39983 -0.5,0.39983l-72.3334,0c-0.2717,0 -0.5,-0.18259 -0.5,-0.39983l0,-93.20061z",
    id: "svg_16",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 11.5,
    fillOpacity: 0,
    x1: 219.78734,
    y1: 105.72271,
    x2: 255.78755,
    y2: 105.27827,
    id: "svg_17",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10.5,
    fillOpacity: 0,
    x1: 212.66239,
    y1: 130.46358,
    x2: 262.9125,
    y2: 130.01913,
    id: "svg_18",
    stroke: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 10.5,
    fillOpacity: 0,
    x1: 212.66239,
    y1: 143.79694,
    x2: 262.9125,
    y2: 143.35249,
    id: "svg_20",
    stroke: "#3D3C3C"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.9fd81aa5bc53fd9958690e5784bbe151.svg";
export { ForwardRef as ReactComponent };